import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { WorkbenchLanguageService } from 'vscode/vscode/vs/workbench/services/language/common/languageService';
import { ILanguageService } from 'vscode/vscode/vs/editor/common/languages/language';
import { LanguageStatusServiceImpl } from './vscode/src/vs/workbench/services/languageStatus/common/languageStatusService.js';
import { ILanguageStatusService } from 'vscode/vscode/vs/workbench/services/languageStatus/common/languageStatusService.service';
import getServiceOverride$1 from '@codingame/monaco-vscode-files-service-override';
import './vscode/src/vs/workbench/contrib/codeEditor/common/languageConfigurationExtensionPoint.js';

function getServiceOverride() {
    return {
        ...getServiceOverride$1(),
        [( ILanguageService.toString())]: new SyncDescriptor(WorkbenchLanguageService, [], false),
        [( ILanguageStatusService.toString())]: new SyncDescriptor(LanguageStatusServiceImpl, [], true)
    };
}

export { getServiceOverride as default };
